import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CopyToClipboard from 'react-copy-to-clipboard';
//widgets
import { withStyles, Tooltip, Typography, Button } from '@material-ui/core';

const ClickCopy = (props) => {
  const {
    disableCapitalization,
    text,
    typeColor,
    value,
    variant,
    context,
    classes,
    highlightText,
  } = props;
  const [isCopied, setCopied] = useState(false);
  const clipCopied = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  const makeHighlight = (text) => {
    const length = text.length;
    const sliceLength = length - highlightText;
    return (
      <span className={classes.highlight}>
        {text.slice(0, sliceLength)}
        <span className={classes.highlight}>
          {text.slice(sliceLength, length)}
        </span>
      </span>
    );
  };

  return (
    <Tooltip
      title={isCopied ? 'Copied!' : 'Copy to Clipboard'}
      className={classes.inherit}
    >
      <CopyToClipboard
        className={
          disableCapitalization ? classes.disableCapitalization : undefined
        }
        text={value ? value : text}
        onCopy={clipCopied}
      >
        <Button onClick={(event) => event.stopPropagation()}>
          <Typography
            variant={variant}
            color={typeColor}
            className={
              context ? classes[context] : classes.inherit + classes.left
            }
          >
            {highlightText ? makeHighlight(text) : text}
          </Typography>
        </Button>
      </CopyToClipboard>
    </Tooltip>
  );
};

ClickCopy.defaultProps = {
  variant: 'subtitle1',
};

ClickCopy.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disableCapitalization: PropTypes.bool,
  variant: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'caption',
    'button',
    'overline',
    'srOnly',
    'inherit',
    'display4',
    'display3',
    'display2',
    'display1',
    'headline',
    'title',
    'subheading',
  ]),
  context: PropTypes.oneOf(['success', 'error', 'warn']),
  typeColor: PropTypes.oneOf(['primary', 'secondary']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  highlightText: PropTypes.number,
};

const styles = (theme) => ({
  disableCapitalization: {
    textTransform: 'inherit',
  },
  success: {
    color: '#28a745',
  },
  error: {
    color: '#dc3545',
  },
  highlight: {
    '&:hover': {
      '& > *': {
        color: theme.palette.primary.main,
      },
    },
  },
  warn: {
    color: '#ffc107',
  },
  inherit: {
    color: 'inherit',
  },
  left: {
    ...theme.modal_leftAlign,
  },
});

export default withStyles(styles)(ClickCopy);
